import { TableHead, SearchData } from "../../../../common/dataClass/Default"

class StockStatusTableHead extends TableHead{
  constructor(name, prop, width, obj) {
    super(name, prop, width, obj)
  }
}

class StockStatusSearchData extends SearchData{
  constructor() {
    super()
    /**国家站点 */
    this.countrySite = ''
    /**店铺 */
    this.store = ''
  }
}

class StockStatusNewMoodule{
  /**产品储备库存量 */
  static NEWPRODUCTTABLEHEAD(){
    let arr = [
      new StockStatusTableHead('产品图片', 'img', '80'),
      new StockStatusTableHead('产品名称', 'img', '100'),
      new StockStatusTableHead('产品型号', 'getNetProfitOfGoodsByTable', '100'),
      new StockStatusTableHead('计算单位', 'stockPrice', '100'),
      new StockStatusTableHead('生产中产品数量', 'getShowNumAndActualNumByTable', '200'),
      new StockStatusTableHead('国内中转仓<br>产品库存数量', 'getShowNumAndActualNumByTable', '200'),
      new StockStatusTableHead('非亚马逊海外中转仓<br>产品库存数量', 'stockPrice', '200'),
      new StockStatusTableHead('国际运输中<br>产品数量', 'getSavePriceByTable', '100'),
      new StockStatusTableHead('中转仓数量', 'disposalNum', '120'),
      new StockStatusTableHead('补货提醒', 'getCostSummaryByTable', '100'),
      new StockStatusTableHead('预警库存量', 'getCostSummaryByTable', '100'),
    ]
    return arr
  }
  /**亚马逊商品库存量 */
  static NEWLISTINGTABLEHEAD(){
    let arr = [
      new StockStatusTableHead('商品图片', 'img', '80'),
      new StockStatusTableHead('商品名称', 'img', '100'),
      new StockStatusTableHead('商品型号', 'getNetProfitOfGoodsByTable', '100'),
      new StockStatusTableHead('ASIN', 'img', '100'),
      new StockStatusTableHead('店铺', 'getNetProfitOfGoodsByTable', '100'),
      new StockStatusTableHead('国家站点', 'img', '100'),
      new StockStatusTableHead('卖家SKU<br>(FNSKU)', 'getNetProfitOfGoodsByTable', '100'),
      new StockStatusTableHead('计算单位', 'stockPrice', '100'),
      new StockStatusTableHead('库存商品所在<br>中转仓数量', 'getShowNumAndActualNumByTable', '150'),
      new StockStatusTableHead('生产中<br>商品数量', 'getShowNumAndActualNumByTable', '150'),
      new StockStatusTableHead('国内中转仓<br>商品库存数量', 'getShowNumAndActualNumByTable', '150'),
      new StockStatusTableHead('非亚马逊海外中转仓<br>商品库存数量', 'stockPrice', '200'),
      new StockStatusTableHead('国际运输中<br>商品数量', 'getSavePriceByTable', '100'),
      new StockStatusTableHead('亚马逊仓<br>可售库存量', 'disposalNum', '120'),
      new StockStatusTableHead('总库存量', 'getCostSummaryByTable', '100'),
      new StockStatusTableHead('亚马逊商品库存体积<br>(CBM)', 'disposalNum', '180'),
      new StockStatusTableHead('亚马逊商品库存<br>预计维持天数', 'disposalNum', '150'),
      new StockStatusTableHead('补货提醒', 'getCostSummaryByTable', '100'),
      new StockStatusTableHead('预警库存量', 'getCostSummaryByTable', '100'),
    ]
    return arr
  }
  /**总库存量表头 */
  static NEWTOTALTABLEHEAD(){
    let arr = [
      new StockStatusTableHead('产品/商品图片', 'img', '80'),
      new StockStatusTableHead('产品/商品名称', 'img', '100'),
      new StockStatusTableHead('产品/商品型号', 'getNetProfitOfGoodsByTable', '100'),
      new StockStatusTableHead('店铺', 'getNetProfitOfGoodsByTable', '100'),
      new StockStatusTableHead('国家站点', 'img', '100'),
      new StockStatusTableHead('ASIN', 'img', '100'),
      new StockStatusTableHead('卖家SKU<br>(FNSKU)', 'getNetProfitOfGoodsByTable', '100'),
      new StockStatusTableHead('计算单位', 'stockPrice', '100'),
      new StockStatusTableHead('生产中<br>数量', 'getShowNumAndActualNumByTable', '150'),
      new StockStatusTableHead('国内中转仓<br>库存数量', 'getShowNumAndActualNumByTable', '150'),
      new StockStatusTableHead('非亚马逊海外<br>中转仓库存数量', 'stockPrice', '200'),
      new StockStatusTableHead('国际运输中<br>数量', 'getSavePriceByTable', '100'),
      new StockStatusTableHead('亚马逊仓<br>库存数量', 'disposalNum', '120'),
      new StockStatusTableHead('产品/商品分类', 'getCostSummaryByTable', '100'),
      new StockStatusTableHead('总库存量', 'getCostSummaryByTable', '100'),
    ]
    return arr
  }
}

export {
  StockStatusSearchData, StockStatusNewMoodule
}
